import { useState, useEffect, PureComponent } from "react";
import { Heading, Box, Text, Center, Tooltip, Flex, useColorMode, 
  useColorModeValue,
  theme,
  Link,
} from "@chakra-ui/react";
// import {
//   FlexibleWidthXYPlot,
//   VerticalBarSeries,
//   LineSeries,
//   Crosshair,
//   XAxis,
// } from "react-vis";
import moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";
import { QuestionIcon } from "@chakra-ui/icons";
import numbro from "numbro";
import { ComposedChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
import { textStyle } from "theme/names";

export function TweetTopics({
  account,
  isLoading = false,
  previousDayStat = undefined,
  dateSeries = [],
  graphBoxCustomStyle = {},
}) {
  const [index, setIndex] = useState(null);
  const [hoveredPoint, setHoveredPoint] = useState<any>();
  const [data, setData] = useState<any>([]);
  const [crosshairValues, setCrosshairValues] = useState([]);
  const { colorMode } = useColorMode();
  
  const [distribution, setDistribution] = useState<any>([]);

  useEffect(() => {
    if (account?.postsTopics?.length) {
      
      let topics = account.postsTopics.sort((a, b) => b.frequency - a.frequency);
      topics = topics.slice(0, 10);
      let newDis = topics.map((topic) => {
        return {
          x: topic.topic.split(" | ")[0],
          engagement: topic.popularity,
          frequency: topic.frequency,
        };
      })

      setDistribution(newDis);
    } else {
      setDistribution([]);
    }
  }, [account]);

  return (
    <Box>
      <Flex justifyContent="center">
        <Heading fontSize="xl" color="#656565">What is {account?.firstName} talking about?</Heading>
        <Tooltip
          hasArrow
          label={
            <>
              <Text textStyle={textStyle["body.medium.light"]}>
                We look at the posts from the last 90 days and analyze them to know what {account?.firstName} is talking about and what resonates with his audience. 
              </Text>
            </>
          }
        >
          <QuestionIcon color="gray.400" mt={1} ml={2} />
        </Tooltip>
      </Flex>
      {!isLoading && distribution.length <= 0 && (
        <Text textStyle={textStyle["body.medium.light"]} p="8" textAlign="center">
          No chart data found. Please try a different timeframe
        </Text>
      )}
      {isLoading && (
        <Center pt={10}>
          <PuffLoader
            color={"#09527c"}
            loading={isLoading}
            cssOverride={{display: "block", margin: "0 auto", borderColor: "red"}}
            size={50}
          />
        </Center>
      )}
      {!isLoading && (
        <Box position="relative" h="300px" maxW="100%" ml={{base: "0", md: "4"}} mt={{ base: "4", md: "8" }} style={graphBoxCustomStyle}>
            
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart
                // width={500}
                height={300}
                data={distribution}
              >
                <XAxis tick={(value) => {
                  console.log('value:', value);
                  console.log('xy:', `translate(${value.x},${value.y})`);
                  return (
                    <svg><a href={"/influencers/" + value?.payload?.value} target="_blank"><text  x={value.x} y={value.y} dy={16} textAnchor="middle" fill="#666">{value?.payload?.value}</text></a></svg>
                  )
                }} dataKey="x" ticks={distribution.map(x => x.x)} type="category" />
                {/* <XAxis axisLine={true} tickLine={false} tick={<CustomizedAxisTick />} dataKey="x"/> */}
                <YAxis yAxisId="left" type="number" hide={true} />
                <Bar yAxisId="left" type="monotone" dataKey="frequency" fill={theme.colors.teal[300]} />
                <Bar yAxisId="left" type="monotone" dataKey="engagement" fill={theme.colors.blue[700]} />
                <Legend verticalAlign="top" height={36}/>
                <RechartsTooltip content={({active, payload, label}) => {
                  // console.log(payload);
                  let frequency: any = payload?.[0]?.value ?? 0;
                  let popularity: any = payload?.[1]?.value ?? 0;
                  let fullTopic = account?.postsTopics?.find(x => x.topic.includes(payload?.[0]?.payload?.x));
                  let topicFormatted = fullTopic?.topicFormatted ?? fullTopic?.topic;
                  return (
                    <Box
                      background={useColorModeValue("white", "gray.600")}
                      padding="4"
                      boxShadow="dark-lg"
                      color={useColorModeValue("#1E1E1E", "white")}
                      borderRadius="lg"
                      width="30"
                      border="none"
                    >
                      <Text textStyle={textStyle["body.medium.light"]} fontSize="md" fontWeight="600">{topicFormatted}</Text>
                      <Text textStyle={textStyle["body.medium.light"]} fontSize="sm"><b>{Math.round((frequency)*100) + "%"}</b>{" of the posts but "}<b>{Math.round((popularity)*100) + "%"}</b>{" of the engagement"}</Text>
                    </Box>
                  )
                }} />
              </ComposedChart>
            </ResponsiveContainer>
        </Box>
      )}
    </Box>
  );
}